import supportModule from '../supportModule';

function support(resources) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    replace: true,
    templateUrl: resources.templateUrls.support
  };
}

supportModule.directive('support', support);

export default support;